<template>
  <CContainer fluid>
    <CRow>
      <CCol col="12" sm="12">
        <CInput 
          label="Buscar:"
          addLabelClasses="text-muted font-weight-bold"
          :value.sync="searchWord" 
          @keyup.enter="getData(1, searchWord)">
          <template #prepend-content>
            <a href="#" @click="getData(1)">
              <i class="bi bi-arrow-clockwise"></i>
            </a>
          </template>
          <template #append-content>
            <a href="#" @click="getData(1, searchWord)">
              <i class="bi bi-search"></i>
            </a>
          </template>
        </CInput>
      </CCol>
    </CRow>
    <CDataTable 
      hover
      :responsive=true
      :fields="fields"
      :items="data"
      :noItemsView="{ noItems: '' }"
      :items-per-page="itemsPerPage">
      <template #seguimiento="{item}">
        <td>
          <div>
            <h4>{{ item.consecutivo }}</h4>
          </div>
          <div>
            <strong>{{ item.clase_Seguimiento }}</strong>
          </div>
          <div>
            <small class="text-muted">{{ moment(item.fecha_Creacion).format("DD/MM/YYYY") }}</small>
          </div>
          <div>
            <small class="text-muted">{{ moment(item.fecha_Creacion).format("HH:MM:SS") }}</small>
          </div>
        </td>
      </template>
      <template #responsable="{item}">
        <td>
          <div>
            <i class="bi bi-person-workspace mr-1"></i>
            <span>{{ item.empleado }}</span>
          </div>
          <div>
            <i class="bi bi-calendar3 mr-1"></i>
            <span>{{ moment(item.fecha_Hora).format("DD/MM/YYYY") }}</span>
          </div>
          <div>
            <i class="bi bi-clock mr-1"></i>
            <span>{{ moment(item.fecha_Hora).format("HH:MM") }}</span>
          </div>
          <div>
            <p>{{ item.comentarios }}</p>
          </div>
        </td>
      </template>
    </CDataTable>
    <CPagination 
      size="sm" 
      class="d-flex justify-content-center" 
      :activePage.sync="page"
      :pages="pageCount"
      @update:activePage="(value) => getData(value, searchWord)">
    </CPagination>

    <LoadingCover v-show="loading" />
  </CContainer>
</template>
<script>
  import moment from "moment";
  import LoadingCover from "@/components/containers/LoadingCover.vue";

  import { dataGridSeguimientos } from "@/apiDataGrids";
  
  const fields = [
    { 
      key: "seguimiento", 
      label: "Seguimiento", 
      _style: "text-align:center" 
    },
    { 
      key: "responsable", 
      label: "Detalle ", 
      _style: "text-align:center" 
    }
  ];

  export default {
    name: "BusinessTracking",
    components: {
      LoadingCover
    },
    data() {
      return {
        loading: false,
        fields,
        page: 1,
        pageCount: 1,
        itemsPerPage: 5,
        searchWord: "",
        data: []
      }
    },
    props: {
      employeeId: String,
      trackingClassId: String,
      directoryId: String,
      dependencyId: String,
      opportunityId: String,
      orderId: String,
      documentId: String,
      dateFilterType: String,
      initDate: String,
      endDate: String
    },
    methods: {
      moment,
      async getData(page, search) {
        this.loading = true;
        this.searchWord = search;

        try {
          const parameters = {
            "Id_Personal": this.employeeId,
            "Id_ClaseSeguimiento": this.trackingClassId,
            "Id_Directorio": this.directoryId,
            "Id_Dependencia": this.dependencyId,
            "Id_Oportunidad": this.opportunityId,
            "Id_Pedido": this.orderId,
            "Id_Documento": this.documentId,
            "Fecha_Inicial": this.initDate,
            "Fecha_Final": this.endDate,
          };

          const { count, results } = await dataGridSeguimientos(this, parameters, page, search);

          this.pageCount = parseInt(count / this.itemsPerPage);

          if (this.pageCount < (count / this.itemsPerPage)) {
            this.pageCount++;
          }

          this.data = results;
        } catch (error) {
          this.$store.commit("setAlert", {
            color: "danger",
            message: `Error al cargar los datos. Error: ${error.status} - ${error.statusText}`,
            show: 5
          });
        } finally {
          this.loading = false;
        }
      }
    },
    created() {
      this.getData();
    },
    mounted() {
    }
  };
</script>
